import { Pipe, PipeTransform } from '@angular/core';
import { MonedaService } from '../../services/moneda-service';

@Pipe({ name: 'currency' })
export class CurrencyPipe implements PipeTransform {
  private currencies;

  constructor(private monedaService: MonedaService) {
    monedaService.Options.subscribe((value) => {
      this.currencies = value;
    });
  }

  transform(value: any) {
    const tmp = this.currencies.find(c => c.ID === value);
    return tmp ? tmp.Simbolo : value;
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/utils/pipes/currency.ts